const MAX_FILE_SIZE = 5 * 1024 * 1024;
const PDF_MIME_TYPE = "application/pdf";

const handleFileInputChange = (event, setFieldValue, fieldName) => {
  const file = event.currentTarget.files[0];

  if (!file) {
    return null;
  }

  if (file.size <= MAX_FILE_SIZE && file.type === PDF_MIME_TYPE) {
    setFieldValue(fieldName, file);
    return file;
  }

  setFieldValue(fieldName, '');
  event.currentTarget.value = '';
  alert('File could not be selected.');
  return null;
};

export { handleFileInputChange };
